export function loadScript(url: string) {
  return new Promise<void>((resolve, reject) => {
    const element = window.document.createElement('script');
    element.async = true;
    element.src = url;
    element.onload = () => {
      resolve();
    };
    element.onerror = () => {
      reject();
    };
    (window.document.body || window.document.head).append(element);
  });
}
